import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { ROUTES } from '@constants';
import { FormType } from '@enums';
import { fetchFormList, useCurrentWorkspaceId, useFormList, useWorkspaceOptions } from '@store';

import { useAppDispatch } from '@hooks';
import { CdnForm } from './CdnForm';

export enum CdnStatus {
  Active = 1,
  InActive = 0,
}

export interface CdnData {
  id: string;
  name: string;
  status: CdnStatus;
  allow_wildcard: boolean;
  allow_domain_count: number;
  allow_total_domain_count: number;
  allow_page_rules_count: number;
}

export const Cdn = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { id: application_id } = useParams();
  const workspace_id = useCurrentWorkspaceId();
  const workspaceList = useWorkspaceOptions();

  const formType = FormType.Cdn;
  const cdnError = useFormList({ formType: FormType.Cdn });

  useEffect(() => {
    if (!application_id) {
      dispatch(fetchFormList({ formType, params: { workspace_id } }));
    }
  }, [workspace_id]);

  useEffect(() => {
    if (cdnError) {
      if (!workspace_id || workspaceList.length <= 0) {
        navigate(ROUTES.homepage);
      }
    }
  }, [cdnError]);

  return <div className="flex flex-1 flex-col gap-8">{<CdnForm />}</div>;
};
